/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleHistoryManagementListOrderResponse } from './CarpsaleHistoryManagementListOrderResponse';

export type CarpsaleHistoryManagementListOrderResponseApiRespoonse = {
    data?: CarpsaleHistoryManagementListOrderResponse;
    status?: CarpsaleHistoryManagementListOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleHistoryManagementListOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

